export const depotTimeWorked = [
  {value: '5', label: '5'},
  {value: '10', label: '10'},
  {value: '15', label: '15'},
  {value: '20', label: '20'},
  {value: '25', label: '25'},
  {value: '30', label: '30'},
  {value: '35', label: '35'},
  {value: '40', label: '40'},
  {value: '45', label: '45'},
  {value: '50', label: '50'},
  {value: '55', label: '55'},
  {value: '60', label: '60 (1 hour)'},
  {value: '75', label: '75'},
  {value: '90', label: '90'},
  {value: '105', label: '105'},
  {value: '120', label: '120 (2 hours)'},
  {value: '150', label: '150'},
  {value: '180', label: '180 (3 hours)'},
  {value: '210', label: '210'},
  {value: '240', label: '240 (4 hours)'},
  {value: '270', label: '270'},
  {value: '300', label: '300 (5 hours)'},
  {value: '330', label: '330'},
  {value: '360', label: '360 (6 hours)'},
  {value: '390', label: '390'},
  {value: '420', label: '420 (7 hours)'},
  {value: '450', label: '450'},
  {value: '480', label: '480 (8 hours)'},
];
